import {
  type ReactNode,
  createContext,
  useContext,
  useSyncExternalStore,
} from 'react';

import type { SessionStore } from './session-store.ts';
import type { ReservationConfig } from './types.ts';

const ReservationContext = createContext<SessionStore<unknown> | null>(null);

export function ReservationProvider<T>({
  config,
  children,
}: {
  config: ReservationConfig<T>;
  children: ReactNode;
}) {
  return (
    <ReservationContext.Provider value={config.store as SessionStore<unknown>}>
      {children}
    </ReservationContext.Provider>
  );
}

export function useReservation<T>() {
  const store = useContext(ReservationContext) as SessionStore<T> | null;
  if (!store) {
    throw new Error(
      'useReservation must be used within a <ReservationProvider>',
    );
  }
  const value = useSyncExternalStore(store.subscribe, store.read, () => null);
  return [value, store.write] as const;
}
